import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import { clsx } from 'clsx';

interface ISpinLoading {
    rootClassName?: string;
    size?: number;
}

export function SpinLoading({ rootClassName, size }: ISpinLoading) {
    return (
        <div
            className={clsx(
                `absolute z-[9999] top-0 left-0 right-0 bottom-0 w-full h-full bg-white opacity-75 rounded-xl 
  flex justify-center items-center pointer-events-auto cursor-not-allowed`,
                rootClassName
            )}
            onClick={(e) => {
                e.stopPropagation();
            }}
        >
            <Spin
                indicator={
                    <LoadingOutlined rev={'test'} spin size={size ?? 32} />
                }
            />
        </div>
    );
}
